// extracted by mini-css-extract-plugin
export default {"header":"style_header__5QS0a","interactive":"style_interactive__Gy+eY","danger":"style_danger__BOjpr","notAvailable":"style_notAvailable__ZogYA"};